import { createAsyncThunk } from '@reduxjs/toolkit';
import { CCMS_BASE_URL } from '../../constants/ccms';

export const contentThunk = createAsyncThunk(
  'contentThunk',
  async (ditaFile, { getState }) => {
    try {
      const state = getState();

      // Check in Redux state
      const existingContent = state.content?.content.find(content => content.ditafile === ditaFile);
      if (existingContent) {
        return existingContent.content;
      }

      // check in IndexedDB
      const iDB = state.counter?.iDB;
      if (iDB) {
        const iDBContent = await iDB.read(ditaFile);
        if (iDBContent) {
          return iDBContent;
        }
      }
      // fetch from URL
      const res = await fetch(`${CCMS_BASE_URL}/${ditaFile}`);
      const content = await res.text();

      if (iDB) {
        await iDB.write(ditaFile, content);
      }

      return content;
    } catch (error) {
      console.log('Error in contentThunk:', error);
      throw error;
    }
  }
);